import { render, staticRenderFns } from "./PageEventInfo.vue?vue&type=template&id=af3d92ee&scoped=true&"
import script from "./PageEventInfo.vue?vue&type=script&lang=js&"
export * from "./PageEventInfo.vue?vue&type=script&lang=js&"
import style0 from "./PageEventInfo.vue?vue&type=style&index=0&id=af3d92ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3d92ee",
  null
  
)

export default component.exports